export const environment = {
  DEV_apiUrl: 'https://wifiws.grandvaliraresorts.com',
  production: true,
  name: 'PRO',
  themes: {
    grandValira: {
      name: "GrandValira",
      favico: 'assets/imgs/grandvalira/favicon.ico',
      font: 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,100;9..40,300;9..40,400;9..40,500;9..40,600;9..40,700;9..40,800;9..40,900;9..40,1000&display=swap',
      fontName: 'DM Sans, sans-serif',
      bg: 'assets/imgs/grandvalira/grandvalira-desktop.png',
      wifiLogo: 'assets/imgs/shared/wifi.png',
      urlForfaitES: 'https://app-assistant.grandvalira.com',
      urlForfaitCA: 'https://app-assistant.grandvalira.com/ca',
      urlForfaitEN: 'https://app-assistant.grandvalira.com/en',
      urlForfaitFR: 'https://app-assistant.grandvalira.com/fr',
      wifiLoaderGif: 'assets/imgs/grandvalira/loading.png',
      qr: {
        img: 'assets/imgs/grandvalira/Qr code scanner.svg'
      },
      datepicker: {
        img: 'assets/imgs/grandvalira/Calendar today.svg'
      },
      checkbox: {
        checkedBgColor: '#77B8DB',
        bgColor: '#E0E0E0'
      },
      header: {
        img: 'assets/imgs/grandvalira/Logotipo_Horizontal_Grandvalira.png',
        lang: {
          default: 'es',
          available: [
            { name: 'es', flag: 'assets/imgs/shared/Flag.png' },
            { name: 'ca', flag: 'assets/imgs/shared/andorra.png' },
            { name: 'fr', flag: 'assets/imgs/shared/francia.png' },
            { name: 'en', flag: 'assets/imgs/shared/reinounido.png' }
          ]
        }
      },
      cards: {
        bgColor: 'rgba(0, 0, 0, 0.70)',
        textColor: '#fff',
        titleColor: '#fff',
        subtitleColor: '#77B8DB',
        separator: true,
        separatorColor: 'rgba(250, 250, 250, 0.50)',
        radius: '0px'
      },
      button: {
        bgColor: 'linear-gradient(270deg, #45B9DD 0.35%, rgba(69, 185, 221, 0.50) 49.28%, rgba(255, 255, 255, 0.50) 98.29%), #77B8DB',
        bgColorSecondary: 'linear-gradient(90deg, rgba(255, 255, 255, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)',
        radius: '8px',
        border: true,
        borderSecondary: true,
        borderColor: '#45B9DD',
        borderColorSecondary: '#FFFFFF',
        borderPadding: '',
        borderPaddingSecondary: '',
        textColor: '#FFFFFF',
        textColorSecondary: '#FFFFFF'
      },
      input: {
        bgColor: '#fff',
        labelColor: '#fff',
        radius: '0px',
        infoImg: 'assets/imgs/shared/Group.svg',
        errorColor: '#FCA5A5'
      },
      link: {
        color: '#77B8DB'
      },
      modal: {
        bgColor: '#fff',
        titleColor: '#77B8DB',
        textColor: '#555',
        borderRadius: '0'
      },
      icon: {
        bgColor: "#77B8DB"
      },
      toggleContainer: {
        color: "#45B9DD",
        bgColor: "#45B9DD",
        textColor: "#FFF"
      },
      apps: {
        color: "#FFFFFF",
        textColor: "#FFFFFF",
        icon: 'assets/imgs/grandvalira/popup.svg',
        close: 'assets/imgs/grandvalira/close.svg',
        googlePlayImage: 'assets/imgs/grandvalira/google-play.svg',
        appStoreImage: 'assets/imgs/grandvalira/app-store.svg',
        googlePlayUrl: "https://api3.mo2o.com/landing/grandvalira",
        appStoreUrl: "https://api3.mo2o.com/landing/grandvalira"
      },
      info: {
        icon: 'assets/imgs/grandvalira/info.svg'
      }
    },
    ordino: {
      name: "Ordino",
      font: 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,100;9..40,300;9..40,400;9..40,500;9..40,600;9..40,700;9..40,800;9..40,900;9..40,1000&display=swap',
      favico: 'assets/imgs/ordino/favicon.ico',
      fontName: 'DM Sans, sans-serif',
      bg: 'assets/imgs/ordino/ordino-desktop.png',
      wifiLogo: 'assets/imgs/shared/wifi_positivo.png',
      urlForfaitES: 'https://app-assistant.ordinoarcalis.com',
      urlForfaitCA: 'https://app-assistant.ordinoarcalis.com/ca',
      urlForfaitEN: 'https://app-assistant.ordinoarcalis.com/en',
      urlForfaitFR: 'https://app-assistant.ordinoarcalis.com/fr',
      wifiLoaderGif: 'assets/imgs/ordino/loading.png',
      qr: {
        img: 'assets/imgs/ordino/Qr code scanner.svg'
      },
      datepicker: {
        img: 'assets/imgs/ordino/Calendar today.svg'
      },
      checkbox: {
        checkedBgColor: 'linear-gradient(180deg, #FF7E6B 0%, #F4634D 100%)',
        bgColor: '#E0E0E0'
      },
      header: {
        img: 'assets/imgs/ordino/Logotipo_Horizontal_OrdinoArcalis.png',
        lang: {
          default: 'es',
          available: [
            { name: 'es', flag: 'assets/imgs/shared/Flag.png' },
            { name: 'ca', flag: 'assets/imgs/shared/andorra.png' },
            { name: 'fr', flag: 'assets/imgs/shared/francia.png' },
            { name: 'en', flag: 'assets/imgs/shared/reinounido.png' }
          ]
        }
      },
      cards: {
        bgColor: 'rgba(255, 255, 255, 0.90)',
        textColor: '#555',
        titleColor: '#003DA6',
        subtitleColor: '#77B8DB',
        separator: true,
        separatorColor: 'rgba(0, 0, 0, 0.40)',
        radius: '16px'
      },
      button: {
        bgColor: 'linear-gradient(180deg, #FF7E6B 0%, #F4634D 100%)',
        bgColorSecondary: '#FFFFFF',
        radius: '68px',
        border: true,
        borderSecondary: true,
        borderColor: '#FF7E6B',
        borderColorSecondary: '#000000',
        borderPadding: '0',
        borderPaddingSecondary: '0',
        textColor: '#FFFFFF',
        textColorSecondary: '#000000'
      },
      input: {
        bgColor: '#E9EDF3',
        labelColor: '#555',
        radius: '4px',
        infoImg: 'assets/imgs/shared/Group.svg',
        errorColor: '#FF0000'
      },
      modal: {
        bgColor: '#fff',
        titleColor: '#77B8DB',
        textColor: '#555',
        borderRadius: '10px'
      },
      link: {
        color: '#77B8DB'
      },
      icon: {
        bgColor: "#F4634D"
      },
      toggleContainer: {
        color: "#003DA6",
        bgColor: "#003DA6",
        textColor: "#FFF"
      },
      apps: {
        color: "#003DA6",
        textColor: "#003DA6",
        icon: 'assets/imgs/ordino/popup.svg',
        close: 'assets/imgs/ordino/close.svg',
        googlePlayImage: 'assets/imgs/ordino/google-play.svg',
        appStoreImage: 'assets/imgs/ordino/app-store.svg',
        googlePlayUrl: "https://api3.mo2o.com/landing/grandvalira",
        appStoreUrl: "https://api3.mo2o.com/landing/grandvalira"
      },
      info: {
        icon: 'assets/imgs/ordino/info.svg'
      }
    },
    palarinsal: {
      name: "Palarinsal",
      font: 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,100;9..40,300;9..40,400;9..40,500;9..40,600;9..40,700;9..40,800;9..40,900;9..40,1000&display=swap',
      favico: 'assets/imgs/palarinsal/favicon.ico',
      fontName: 'DM Sans, sans-serif',
      bg: 'assets/imgs/palarinsal/pal-desktop.png',
      wifiLogo: 'assets/imgs/shared/wifi_positivo.png',
      urlForfaitES: 'https://app-assistant.palarinsal.com',
      urlForfaitCA: 'https://app-assistant.palarinsal.com/ca',
      urlForfaitEN: 'https://app-assistant.palarinsal.com/en',
      urlForfaitFR: 'https://app-assistant.palarinsal.com/fr',
      wifiLoaderGif: 'assets/imgs/palarinsal/loading.png',
      qr: {
        img: 'assets/imgs/palarinsal/Qr code scanner.svg'
      },
      datepicker: {
        img: 'assets/imgs/palarinsal/Calendar today.svg'
      },
      checkbox: {
        checkedBgColor: '#FFCC00',
        bgColor: '#E0E0E0'
      },
      header: {
        img: 'assets/imgs/palarinsal/Logotipo_Horizontal_PalArinsal.png',
        lang: {
          default: 'es',
          available: [
            { name: 'es', flag: 'assets/imgs/shared/Flag.png' },
            { name: 'ca', flag: 'assets/imgs/shared/andorra.png' },
            { name: 'fr', flag: 'assets/imgs/shared/francia.png' },
            { name: 'en', flag: 'assets/imgs/shared/reinounido.png' }
          ]
        }
      },
      modal: {
        bgColor: '#fff',
        titleColor: '#414141',
        textColor: '#555555',
        borderRadius: '0'
      },
      cards: {
        bgColor: 'rgba(250, 250, 250, 250.50)',
        textColor: '#000000',
        titleColor: '#000000',
        separator: true,
        separatorColor: '#FFCC00',
        radius: '0px'
      },
      button: {
        bgColor: '#FFCC00',
        bgColorSecondary: '#FFFFFF',
        radius: '',
        border: true,
        borderSecondary: true,
        borderColor: '#FFCC00',
        borderColorSecondary: '#000000',
        borderPadding: '0',
        borderPaddingSecondary: '0',
        textColor: '#000000',
        textColorSecondary: '#000000'
      },
      input: {
        bgColor: '#F0F2F5',
        labelColor: '#000000',
        infoImg: 'assets/imgs/shared/Group.svg',
        errorColor: '#FF0000'
      },
      link: {
        color: '#575968'
      },
      icon: {
        bgColor: "#575968"
      },
      toggleContainer: {
        color: "#FFCC00",
        bgColor: "#FFCC00",
        textColor: "#000000"
      },
      apps: {
        color: "#FFCC00",
        textColor: "#000000",
        icon: 'assets/imgs/palarinsal/popup.svg',
        close: 'assets/imgs/palarinsal/close.svg',
        googlePlayImage: 'assets/imgs/palarinsal/google-play.svg',
        appStoreImage: 'assets/imgs/palarinsal/app-store.svg',
        googlePlayUrl: "https://api3.mo2o.com/landing/grandvalira",
        appStoreUrl: "https://api3.mo2o.com/landing/grandvalira"
      },
      info: {
        icon: 'assets/imgs/palarinsal/info.svg'
      }
    }
  },
};
